function calcChecker1(firstNineDigits) {
  let sum = null;

  for (let j = 0; j < 9; ++j) {
    sum += firstNineDigits.toString().charAt(j) * (10 - j);
  }

  const lastSumChecker1 = sum % 11;
  const checker1 = lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;

  return checker1;
}

function calcChecker2(cpfWithChecker1) {
  let sum = null;

  for (let k = 0; k < 10; ++k) {
    sum += cpfWithChecker1.toString().charAt(k) * (11 - k);
  }
  const lastSumChecker2 = sum % 11;
  const checker2 = lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;

  return checker2;
}

function cleaner(value) {
  const digits = value.replace(/[^\d]/g, "");
  return digits;
}

function verificacaoGeral(cnpj) {
  let excludeArray = [
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999"
  ];

  if (cnpj === "") return false;
  if (cnpj.length !== 14) return false;
  if (excludeArray.some(o => cnpj === o)) return false;

  return true;
}

function verificarDigito(cnpj, pesos) {
  let numbers = cnpj.split("").slice(0, pesos.length);
  // Soma numeros do CNPJ baseado nos pesos
  let acumuladora = numbers.reduce((anterior, atual, index) => {
    return anterior + atual * pesos[index];
  }, 0);
  let resto = acumuladora % 11;
  let digito = resto < 2 ? 0 : 11 - resto;
  return parseInt(cnpj[pesos.length]) === digito;
}

const validations = {
  cpfValidate(value) {
    const cleanCPF = cleaner(value);
    const firstNineDigits = cleanCPF.substring(0, 9);
    const checker = cleanCPF.substring(9, 11);
    let result = false;

    for (let i = 0; i < 10; i++) {
      if (firstNineDigits + checker === Array(12).join(i)) {
        return false;
      }
    }

    const checker1 = calcChecker1(firstNineDigits);
    const checker2 = calcChecker2(`${firstNineDigits}${checker1}`);

    if (checker.toString() === checker1.toString() + checker2.toString()) {
      result = true;
    } else {
      result = false;
    }
    return result;
  },
  cnpjValidate(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    let pesosDigito1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let pesosDigito2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    return (
      verificacaoGeral(cnpj) &&
      verificarDigito(cnpj, pesosDigito1) &&
      verificarDigito(cnpj, pesosDigito2)
    );
  }
};

export default validations;
